import { useEffect, useRef, useState } from 'react';

export const MIN_CHARS = 2;
export const DELAY_MS = 300;

// Matching records for the header text, one group per source, fetched after a short pause.
// Answers for older text are dropped; a source that fails shows its own error.
export default function useHeaderSearch(text, sources) {
  const q = text.trim();
  const [res, setRes] = useState({ q: '', groups: [], status: 'idle' });
  const seq = useRef(0);
  const keys = sources.map((s) => s.key).join(',');

  useEffect(() => {
    const id = ++seq.current;
    if (q.length < MIN_CHARS || !sources.length) {
      setRes({ q, groups: [], status: 'idle' });
      return undefined;
    }
    setRes({ q, groups: [], status: 'loading' });
    const t = setTimeout(async () => {
      const got = await Promise.allSettled(sources.map((s) => s.fetch(q)));
      if (id !== seq.current) return;
      const groups = got.map((r, i) => (r.status === 'fulfilled'
        ? { source: sources[i], ...r.value, error: false }
        : { source: sources[i], items: [], total: 0, error: true }));
      setRes({ q, groups, status: groups.every((g) => g.error) ? 'error' : 'ready' });
    }, DELAY_MS);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, keys]);

  return res;
}
